import { render, staticRenderFns } from "./TypePropertyDetailBtn.vue?vue&type=template&id=4935235b"
import script from "./TypePropertyDetailBtn.vue?vue&type=script&lang=js"
export * from "./TypePropertyDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports